import { render, staticRenderFns } from "./AlbumArticleList.vue?vue&type=template&id=17cb050c&"
import script from "./AlbumArticleList.vue?vue&type=script&lang=js&"
export * from "./AlbumArticleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports